import { MANUALS_ENTRYPOINT } from "config/api";

export async function scrapAvalaibleManuals(){
  const response =  await fetch(MANUALS_ENTRYPOINT)
  const html = await response.text()
  const re = /href="QyScore_([0-9]+)_([0-9]+)_([0-9]*)[^"]+_([0-9]+)_([A-Z]{2})(_(BETA|FDA))?.pdf+"/gm
  const matchs = html.matchAll(re);
  const relevantGroups = [...matchs]?.map(m => m.slice(0, 6));
  return relevantGroups
}